import React, { Component } from 'react';
import { Grid, Form, Message } from 'semantic-ui-react';
import { forEach } from 'lodash';
import Axios from 'axios';
import menuItems from '../Header/MenuItems/menuItems.json';

export default class MessageForm extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {

    };
  }

  state = {}

  onChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  }

  onSubmit = () => {
    const { title, message } = this.state;
    Axios.post('/sendPushNotification.php', {
      notification: {
        title,
        body: message,
        click_action: 'https://www.jtvsuriname.com',
        icon: 'https://www.jtvsuriname.com/favicon.ico',
      },
      to: '/topics/general',
    }).then(() => {
      this.setState({messageSent: true}); /* eslint-disable-line */
    }).catch((response) => {
      this.setState({ error: response });
    });
  }

  render() {
    const options = [];
    forEach(menuItems, ({ name, link: linkValue }) => {
      options.push({ key: name, value: linkValue, text: name });
    });
    options.push({ key: 'Tarieven', value: '/tarieven', text: 'Tarieven' });
    const { title, message, link, error, messageSent } = this.state;
    return (
      <Grid>
        <Grid.Column>
          <Form
            onSubmit={this.onSubmit}
            error={error}
            success={messageSent}
          >
            <Form.Input
              label="De titel van uw bericht."
              placeholder="Titel"
              name="title"
              value={title}
              onChange={this.onChange}
            />
            <Form.TextArea
              label="Typ hier het bericht dat u wilt versturen naar alle gebruikers van de app.
                    Enkel de eerste 40 karakters zal de gebruiker meteen zien. De rest zal pas
                    getoond worden wanneer de gebruiker de notificatie openklikt."
              placeholder="Bericht"
              name="message"
              value={message}
              onChange={this.onChange}
            />
            <span>Characters: {message ? message.length : 0}</span>
            <Form.Select
              label="Naar welke pagina moet de notificatie verwijzen?"
              placeholder="Link"
              name="link"
              value={link}
              options={options}
              onChange={this.onChange}
            />
            <Message success header="Success" content="Het bericht is verstuurd!" />
            <Message error header="Error" content="Er is iets fout gegaan, contacteer de webmaster." />
            <Form.Button className="Admin__Message__Button">Submit</Form.Button>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/MessageForm.js